<template>
    <div class="col-sm-12" :class="(inPaymentValidation?'processing':'')">
        <h3>Order #{{orderNumber}} received</h3>
        <p>Order payment: <strong>{{paymentMethod.name}}</strong></p>
        <div class="progressor"></div>

        <div v-if="paymentMethod.code=='PS-CC'" class="col-sm-12">
            <div v-if="inPaymentValidation" >
                Waiting for payment confirmation...
                <br>
            </div>
            <div v-if="paymentError" class="alert alert-warning">{{paymentError}}</div>
            <div v-if="paymentCompleted">
                <div class="alert alert-success">Payment received</div>
                <p>You can pickup your order at [time] from [location].</p>
            </div>
        </div>
        <p v-else>You can pickup your order at [time] from [location].</p>
    </div>
</template>

<script>
    export default {
        name: 'Finalize',
        props: {
            width: String
        },
        data: function () {
            return {
                inPaymentValidation: false,
                paymentError: false,
                transactionCounter: 1,
                attempts: 10,
            }
        },
        computed: {
            paymentMethod () {
                if (this.$store.state.cart.payments.length) {
                    return this.$store.state.cart.payments[0].method
                } else {
                    return null
                }
            },
            inProgress () {
                return this.$store.state.inProgress
            },
            orderNumber() {
                return  this.$store.state.cart.number
            },
            paymentCompleted() {
                if (this.$store.state.cart.payments[0].state=='completed') {
                    return true
                } else {
                    return false
                }
            }
        },
        mounted() {
            this.$store.dispatch('tryToRecover')
        },
        methods: {
            payMe() {
                let params = {
                    checkout_url: "https://checkout.bepaid.by",
                    checkout: {
                        iframe: true,
                        test: true,
                        transaction_type: "payment",
                        public_key: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvextn45qf3NiNzqBYXMvcaSFlgoYE/LDuDDHtNNM4iWJP7BvjBkPcZu9zAfo5IiMxl660r+1E4PYWwr0iKSQ8+7C/WcSYwP8WlQVZH+2KtPmJgkPcBovz3/aZrQpj6krcKLklihg3Vs++TtXAbpCCbhIq0DJ3T+khttBqTGD+2x2vOC68xPgMwvnwQinfhaHEQNbtEcWWXPw9LYuOTuCwKlqijAEds4LgKSisubqrkRw/HbAKVfa659l5DJ8QuXctjp3Ic+7P2TC+d+rcfylxKw9c61ykHS1ggI/N+/KmEDVJv1wHvdy7dnT0D/PhArnCB37ZDAYErv/NMADz2/LuQIDAQAB",
                        order: {
                            amount: this.$store.state.cart.totals.total,
                            currency: this.$store.state.cart.currency,
                            description: "Оплата заказа N" + this.orderNumber,
                            tracking_id: this.$store.state.cart.tokenValue + '_' + this.transactionCounter
                        },
                        settings: {
                            language: "ru",
                            notification_url: 'https://adz.typo3demosite.com/shop-api/pay/'+this.$store.state.cart.tokenValue
                        },
                    },
                    payment_method: {
                        types: ["credit_card"],
                    },
                    closeWidget: (status)=>{
                        switch (status) {
                            case 'successful':
                            case 'pending':
                            case 'redirected':
                                this.inPaymentValidation = true
                                this.attempts = 10
                                this.payTimer = setTimeout(this.validatePayment(), 3000);
                                break;
                            case 'null':
                                break;
                            default:
                                this.paymentError = 'Возникла ошибка при попытке оплаты. Попробуйте ещё раз.'
                                this.transactionCounter++
                                break;
                        }
                    }

                };
                new window.BeGateway(params).createWidget();
            },
            validatePayment() {
                clearTimeout(this.payTimer)
                console.log('tick')
                if (!this.inProgress) {
                    if (!this.paymentCompleted) {
                        this.$store.dispatch('updateOrder')
                    }
                }
                if (!this.paymentCompleted && this.attempts>0) {
                    this.attempts--
                    this.payTimer = setTimeout(this.validatePayment, 3000)
                } else {
                    if (this.attempts<=0) {
                        this.paymentError = 'Что-то пошло не так. Попробуйте ещё раз.'
                        this.transactionCounter++
                    }
                    this.attempts = 10
                    this.inPaymentValidation = false
                }
            }
        },
        watch: {
            inPaymentValidation (newValue) {
                if (newValue) {
                    this.paymentError = false
                }
            }
        }
    }
</script>